
<script>
import ButtonNormal from '@/components/buttons/ButtonNormal.vue';
export default {
    name: 'WizardFirstUserThirdStep',
    components: { ButtonNormal },
    props: {
        title: String,
        description: String,
        image: String,
        customData: Object
    },
    methods: {
        getImage(name) {
            const images = require.context(
                '../../../assets/wizard',
                false,
                /\.svg$/
            );
            return images('./' + name + '.svg');
        }
    }
};
</script>

<template>
  <div class="wizard-content-step">
    <div class="wizard-content-header">
        <div class="description">
            <h1>{{title}}</h1>
            <p v-html="description"> </p>
        </div> 
    </div>  
    <div class="blocks">
        <div class="block grid-column-1">
            <div class="image" >
                <img :src="getImage(image)" alt="Wizard image"/>
            </div>
        </div>
        <div class="block grid-column-2">
            <div class="info-text">
                <p>
                    {{customData.contentText}}
                </p>
            </div>
        </div>
    </div>
    <div class="blocks one-column" v-if="!customData.isLast">
        <div class="actions center">
            <ButtonNormal @onClick="$router.push('/')" class="right" buttonTitle="Zum Dashboard" cssClass="btn btn-primary"/>
        </div>
    </div>
    <div class="blocks" v-if="customData.isLast">
        <div class="actions grid-column-1 right">
            <ButtonNormal @onClick="$router.push('/')" class="right" buttonTitle="Zum Dashboard" cssClass="btn btn-secondary"/>
        </div>
    <div class="actions grid-column-2">
            <ButtonNormal @onClick="$router.push('/wizard/second-user')" class="left" buttonTitle="Weiteren Benutzer anlegen" cssClass="btn btn-primary"/>
        </div>
    </div>
 </div>
</template>

<style lang="scss" scoped>
@import './step.scss';

.info-text {
    display: table;
    height: 100%;
    width: 100%;

    p {
        text-align: center;
        display: table-cell;
        vertical-align: middle;
    }
}
</style>
